import type { ShapeProps } from "./index";
import { generateRoundedPath } from "./utils";

export function Pentagon({ width, height, ...svgAttributes }: ShapeProps) {
  // Regular pentagon: top vertex pointing up, flat edge at bottom.
  // Angles: 90°, 162°, 234°, 306°, 18° (starting from top, going clockwise).
  const cx = width / 2;
  const cy = height / 2;
  const rx = width / 2;
  const ry = height / 2;

  const points: [number, number][] = [];
  for (let i = 0; i < 5; i++) {
    const angle = (Math.PI * 2 * i) / 5 - Math.PI / 2; // start at top
    points.push([cx + rx * Math.cos(angle), cy + ry * Math.sin(angle)]);
  }

  return <path d={generateRoundedPath(points, 6)} {...svgAttributes} />;
}
